<template>
  <div class="text-center">
    <!--    <page-header></page-header>-->
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col
        cols="12"
        class="icon-title word-type-txt pb-4 d-flex justify-space-between"
      >
        <div><icon-application :width="24" :height="24" />학자금</div>
      </v-col>
    </v-row>
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>학자금 구분</v-list-item-title>
          <v-list-item-subtitle> 대학학자금 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>대상자명</v-list-item-title>
          <v-list-item-subtitle> 홍길동 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>생년월일</v-list-item-title>
          <v-list-item-subtitle> 1990.01.01 / 남 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>학교명</v-list-item-title>
          <v-list-item-subtitle> 서울대학교 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>학년</v-list-item-title>
          <v-list-item-subtitle> 1학년 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청분기</v-list-item-title>
          <v-list-item-subtitle> 1분기 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청분기</v-list-item-title>
          <v-list-item-subtitle> 1분기 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청금액</v-list-item-title>
          <v-list-item-subtitle> 5,000,000 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기지급액</v-list-item-title>
          <v-list-item-subtitle> 0 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>지급한도/연</v-list-item-title>
          <v-list-item-subtitle> 10,000,000 </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>지급예정일</v-list-item-title>
          <v-list-item-subtitle> 2024-04-05 </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
    <!--하단버튼
        <v-bottom-navigation
          v-model="value"
          :input-value="active"
          fixed
          scroll-threshold="500"
          height="96"
        >
          <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
            <v-col cols="12">
              <v-btn
                block
                elevation="0"
                class="btn-fixed btn-blue"
                @click="$emit('goApplMenuList')"
              >
                <span class="white--text">다음</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-bottom-navigation-->
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import IconApplication from '@/assets/customIcon/IconApplication.vue';

export default {
  computed: {},
  components: {
    //  PageHeader,
    IconApplication,
  },
};
</script>
